import { render, staticRenderFns } from "./CuNavbar.vue?vue&type=template&id=32475f66&"
import script from "./CuNavbar.vue?vue&type=script&lang=js&"
export * from "./CuNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports